/* VERVE commercial pages: shared behaviour (concepts, Sep 2026). No dependencies.
   - Audience: ?for=founder|owner|facility|franchise (or #owner etc.) + in-page switch
   - Message match: ?angle=<key> shows the matching [data-angle] hero headline
   - Landing header, sticky mobile bar, stepped form, short direct form + booking sheet, video modal
   In Shopify this file becomes assets/verve-commercial.js, loaded by the landing sections. */
(function () {
  'use strict';
  var AUDS = ['founder', 'owner', 'facility', 'franchise'];
  var root = document.documentElement;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var params = (function () { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } })();
  function track(name, data) {
    // verve_lead carries buyer_type (commercial|home) and lead_id: GTM sends Meta's Lead from it (commercial only), and
    // lead_id doubles as Meta's eventID, so a later server-side (CAPI) copy of the same lead is counted once.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'verve_' + name, audience: root.dataset.for }, data || {}));
  }
  window.verveTrack = track;
  function leadId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'vl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function buyer(v) { return v === 'HOME' ? 'home' : v === 'COMMERCIAL' ? 'commercial' : 'not chosen'; }

  /* ---------- audience ---------- */
  var audChosen = false; // true once the visitor picks (or arrives via ?for=), so a lead never claims a default as their answer
  function initialAud() {
    var q = (params.get('for') || '').toLowerCase();
    if (AUDS.indexOf(q) > -1) { audChosen = true; return q; }
    var h = (location.hash || '').replace('#', '').toLowerCase();
    if (AUDS.indexOf(h) > -1) { audChosen = true; return h; }
    var s = store.get('verve_aud');
    if (AUDS.indexOf(s) > -1) return s;
    return root.dataset.for || 'founder';
  }
  function setAud(aud, opts) {
    if (AUDS.indexOf(aud) < 0) aud = 'founder';
    root.dataset.for = aud;
    document.querySelectorAll('[data-aud]').forEach(function (el) {
      var list = el.getAttribute('data-aud').split(/\s+/);
      el.hidden = !(list.indexOf(aud) > -1 || list.indexOf('all') > -1);
    });
    document.querySelectorAll('input[data-aud-input]').forEach(function (i) { i.checked = i.value === aud; });
    store.set('verve_aud', aud);
    if (opts && opts.user) {
      audChosen = true;
      try { var u = new URL(location.href); u.searchParams.set('for', aud); history.replaceState(null, '', u); } catch (e) {}
      track('audience_change', { to: aud });
    }
    document.dispatchEvent(new CustomEvent('verve:aud', { detail: aud }));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-aud-input]')) setAud(t.value, { user: true });
  });
  window.verveSetAud = setAud;

  /* ---------- message match (?angle=) ---------- */
  function applyAngle() {
    var a = (params.get('angle') || '').toLowerCase();
    var h = (location.hash || '').replace('#', '').toLowerCase();
    if (!a && ['lease', 'cost', 'layout', 'date'].indexOf(h) > -1) a = h;
    document.querySelectorAll('[data-angles]').forEach(function (group) {
      var items = group.querySelectorAll('[data-angle]');
      var has = a && group.querySelector('[data-angle="' + a + '"]');
      items.forEach(function (el) {
        var k = el.getAttribute('data-angle');
        el.hidden = has ? k !== a : k !== 'default';
      });
    });
  }

  /* ---------- header + mobile bar ---------- */
  function initChrome() {
    var hdr = document.querySelector('.lhdr');
    var bar = document.querySelector('.mbar');
    var solidAfter = hdr && hdr.getAttribute('data-solid-after');
    var hideNear = document.querySelectorAll('[data-hide-mbar]');
    var hidden = 0;
    if ('IntersectionObserver' in window && hideNear.length && bar) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { en.target._in = en.isIntersecting; });
        hidden = Array.prototype.some.call(hideNear, function (n) { return n._in; });
        onScroll();
      }, { threshold: 0.08 });
      hideNear.forEach(function (n) { io.observe(n); });
    }
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (hdr) {
        var limit = 40;
        if (solidAfter) { var el = document.querySelector(solidAfter); if (el) limit = el.offsetTop + el.offsetHeight - 80; }
        var solid = y > limit;
        hdr.classList.toggle('lhdr--solid', solid);
        if (hdr.hasAttribute('data-light')) hdr.classList.toggle('lhdr--light', !solid);
      }
      if (bar) {
        var after = bar.getAttribute('data-after'), from = window.innerHeight * 0.9;
        if (after) { var a = document.querySelector(after); if (a) from = a.getBoundingClientRect().top + y - window.innerHeight * 0.6; }
        bar.classList.toggle('is-on', y > from && !hidden);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- stepped form ---------- */
  function initForms() {
    document.querySelectorAll('[data-fx]').forEach(function (form) {
      var steps = Array.prototype.slice.call(form.querySelectorAll('.fx__step'));
      var meter = form.querySelector('.fx__meter');
      var count = form.querySelector('.fx__count');
      var err = form.querySelector('.fx__err');
      var i = 0;
      if (meter) meter.innerHTML = steps.map(function () { return '<i></i>'; }).join('');
      function show(n, silent) {
        i = Math.max(0, Math.min(steps.length - 1, n));
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        if (meter) meter.querySelectorAll('i').forEach(function (b, k) { b.classList.toggle('on', k <= i); });
        if (count) count.textContent = 'STEP ' + (i + 1) + ' OF ' + steps.length;
        if (err) err.hidden = true;
        form.querySelectorAll('[data-fx-back]').forEach(function (b) { b.hidden = i === 0; });
        if (!silent) track('form_step', { step: i + 1, form: form.id });
      }
      function valid(step) {
        var ok = true;
        step.querySelectorAll('[data-required-group]').forEach(function (g) {
          if (!g.querySelector('input:checked')) ok = false;
        });
        step.querySelectorAll('input[required],textarea[required]').forEach(function (f) {
          if (f.offsetParent !== null && !f.checkValidity()) ok = false;
        });
        return ok;
      }
      function next() {
        if (!valid(steps[i])) {
          if (err) { err.hidden = false; err.textContent = steps[i].getAttribute('data-error') || 'Choose an option to keep going.'; }
          var bad = steps[i].querySelector('input:invalid');
          if (bad) bad.focus();
          return;
        }
        if (i < steps.length - 1) { show(i + 1); scrollIntoViewIfNeeded(form); }
      }
      form.addEventListener('click', function (e) {
        var t = e.target.closest('[data-fx-next],[data-fx-back]');
        if (!t) return;
        e.preventDefault();
        if (t.hasAttribute('data-fx-next')) next(); else show(i - 1);
      });
      // single-choice steps advance on their own. A tap on the tile that is already
      // selected fires no change event, so remember its state at pointerdown and advance on click.
      var wasChecked = null;
      form.addEventListener('pointerdown', function (e) {
        var tile = e.target.closest('.fx__step[data-auto] .fx__tile');
        var inp = tile && tile.querySelector('input[type=radio]');
        wasChecked = inp && inp.checked ? inp : null;
      });
      form.addEventListener('click', function (e) {
        var tile = e.target.closest('.fx__step[data-auto] .fx__tile');
        if (!tile || !wasChecked || !tile.contains(wasChecked)) return;
        wasChecked = null;
        setTimeout(function () { if (steps[i].contains(tile)) next(); }, 200);
      });
      form.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.fx__step[data-auto] input[type=radio]:checked')) { e.preventDefault(); next(); }
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.type === 'radio' && t.closest('.fx__step[data-auto]')) {
          setTimeout(function () { if (steps[i].contains(t)) next(); }, 260);
        }
      });
      // file drop
      form.querySelectorAll('.fx__drop').forEach(function (drop) {
        var input = drop.querySelector('input[type=file]');
        var out = form.querySelector(drop.getAttribute('data-out'));
        function list(files) {
          if (!out) return;
          if (!files || !files.length) { out.hidden = true; return; }
          out.hidden = false;
          out.querySelector('span').textContent = Array.prototype.map.call(files, function (f) { return f.name; }).join(', ');
        }
        drop.addEventListener('click', function () { input.click(); });
        drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
        input.addEventListener('change', function () { list(input.files); });
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
        drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) { try { input.files = e.dataTransfer.files; } catch (x) {} list(e.dataTransfer.files); } });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!valid(steps[i])) { next(); return; }
        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = v instanceof File ? (v.name || '') : v; });
        data.audience = root.dataset.for;
        data.angle = params.get('angle') || '';
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) data[k] = params.get(k); });
        // follow-up questions after the short form: same contact, and the first note travels with the answers
        var isEnrich = form.hasAttribute('data-enrich');
        if (isEnrich) {
          var first = window.verveLastLead || {};
          ['firstname', 'lastname', 'email', 'phone', 'notes', 'angle', 'buyer_type', 'lead_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (first[k] && !data[k]) data[k] = first[k]; });
        }
        window.verveLastLead = data;
        var done = document.querySelector(form.getAttribute('data-done'));
        function showDone() {
          track(isEnrich ? 'lead_details' : 'lead', { form: form.id, buyer_type: buyer(data.buyer_type), lead_id: data.lead_id || '' });
          if (isEnrich) { var intro = form.parentNode.querySelector('.enrich__intro'); if (intro) intro.hidden = true; }
          if (!done) return;
          done.querySelectorAll('[data-fill]').forEach(function (el) {
            var k = el.getAttribute('data-fill');
            if (data[k]) el.textContent = data[k];
          });
          form.hidden = true; done.hidden = false;
          scrollIntoViewIfNeeded(done);
        }
        // Concept files send nothing. The Shopify build adds data-hubspot="portal/formGuid" (and data-portal on Gym Launch).
        var hs = form.getAttribute('data-hubspot');
        if (!hs) { showDone(); return; }
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        sendLead(form, data, hs).then(showDone).catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (err) { err.hidden = false; err.textContent = 'That didn’t send. Please try again, or call us on 1300 1947 48.'; }
        });
      });
      // keep step 1 audience tiles in sync with the page switch
      document.addEventListener('verve:aud', function (ev) {
        form.querySelectorAll('input[name="audience"]').forEach(function (r) { r.checked = r.value === ev.detail; });
      });
      show(0, true);
    });
  }

  /* ---------- short direct form (.qf), the booking sheet, and the optional follow-up questions ---------- */
  function initQuick() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-qf]'));
    if (!forms.length) return;
    var sheet = document.getElementById('qsheet');
    var enrich = document.querySelector('[data-enrich-home]');
    var sent = null;
    // the follow-up asks who they are: never pre-tick the page's default as if they had answered
    if (enrich && !audChosen) enrich.querySelectorAll('input[name="audience"]').forEach(function (r) { r.checked = false; });
    function openSheet(from) {
      if (!sheet || typeof sheet.showModal !== 'function') return false; // no <dialog>: the link scrolls to the form instead
      if (!sheet.open) sheet.showModal();
      root.classList.add('qs-open');
      var first = sheet.querySelector('input');
      if (first && !sent && matchMedia('(pointer: fine)').matches) first.focus(); // phones: no keyboard until they tap a field
      track('form_open', { from: from || '' });
      return true;
    }
    if (sheet) {
      sheet.addEventListener('close', function () {
        root.classList.remove('qs-open');
        // closed with the follow-up questions still open: park them under the form at the bottom of the page
        if (enrich && sheet.contains(enrich) && !enrich.querySelector('[data-enrich]').hidden) {
          var home = document.querySelector('#design-form');
          var slot = home && home.parentNode.querySelector('[data-enrich-slot]');
          if (slot) slot.appendChild(enrich);
        }
      });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-qsheet-close]')) sheet.close();
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-qf-open]');
      if (t && openSheet(t.getAttribute('data-qf-open'))) e.preventDefault();
    });
    function fill(form, data, withEnrich) {
      var done = form.parentNode.querySelector('.qf-done');
      if (!done) return null;
      done.querySelectorAll('[data-fill]').forEach(function (el) { var k = el.getAttribute('data-fill'); if (data[k]) el.textContent = data[k]; });
      form.hidden = true; done.hidden = false;
      if (withEnrich && enrich) {
        var slot = done.querySelector('[data-enrich-slot]');
        if (slot) { slot.appendChild(enrich); enrich.hidden = false; }
      }
      return done;
    }
    forms.forEach(function (form) {
      var err = form.querySelector('.fx__err');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bad = Array.prototype.filter.call(form.querySelectorAll('input[required],select[required],textarea[required]'), function (f) { return !f.checkValidity(); });
        if (bad.length) {
          if (err) { err.hidden = false; err.textContent = form.getAttribute('data-error') || 'Add your name, mobile and email, and choose commercial or home, so we can call you about your design.'; }
          bad[0].focus();
          return;
        }
        if (err) err.hidden = true;
        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : ''; });
        if ('fullname' in data) { // one Name field (pages A and B); page C asks first and last name separately for the portal
          var parts = data.fullname.split(/\s+/);
          data.firstname = parts.shift() || '';
          data.lastname = parts.join(' ');
          delete data.fullname;
        }
        if (audChosen) data.audience = root.dataset.for; else data.page_version = AUD[root.dataset.for] || root.dataset.for;
        data.angle = params.get('angle') || '';
        data.lead_id = leadId();
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) data[k] = params.get(k); });
        var btn = form.querySelector('[type=submit]');
        function ok() {
          sent = data;
          window.verveLastLead = data;
          track('lead', { form: form.id, buyer_type: buyer(data.buyer_type), lead_id: data.lead_id });
          var done = fill(form, data, true);
          forms.forEach(function (f) { if (f !== form) fill(f, data, false); }); // one lead: every copy of the form now says so
          if (done && !form.closest('dialog')) scrollIntoViewIfNeeded(done);
        }
        // Concept files send nothing. The Shopify build adds data-hubspot="portal/formGuid".
        var hs = form.getAttribute('data-hubspot');
        if (!hs) { ok(); return; }
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        sendLead(form, data, hs).then(ok).catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (err) { err.hidden = false; err.textContent = 'That didn’t send. Please try again, or call us on 1300 1947 48.'; }
        });
      });
    });
  }

  /* ---------- lead delivery (Shopify build only) ---------- */
  function cookieVal(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  var LABELS = { buyer_type: 'Commercial or home', audience: 'Buyer', page_version: 'Page version seen (audience not chosen)', stage: 'Stage', size: 'Space', budget: 'Equipment budget', opening: 'Opening', postcode: 'Site postcode', notes: 'Notes', gym_type: 'Gym type', suburb: 'Suburb or postcode', angle: 'Ad angle' };
  var AUD = { founder: 'Opening a first gym', owner: 'Upgrading or expanding', facility: 'Facility', franchise: 'Multi-site or franchise' };
  function summary(form, data) {
    var parts = [form.getAttribute('data-lead-label') || 'Website lead'];
    Object.keys(LABELS).forEach(function (k) {
      var v = data[k]; if (!v) return;
      if (k === 'audience') v = AUD[v] || v;
      if (k === 'buyer_type') v = v === 'HOME' ? 'Home gym' : v === 'COMMERCIAL' ? 'Commercial gym, studio or facility' : v;
      parts.push(LABELS[k] + ': ' + v);
    });
    if (data.floorplan) parts.push('Floor plan chosen on the form: ' + data.floorplan + ' (ask them to text or email it)');
    Object.keys(data).filter(function (k) { return /^calc_/.test(k); }).forEach(function (k) { parts.push(k.replace('calc_', 'Calculator ') + ': ' + data[k]); });
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (data[k]) parts.push(k + ': ' + data[k]); });
    if (!data.buyer_type) parts.push('Commercial or home: not chosen (sent as COMMERCIAL because HubSpot requires a value)');
    if (data.lead_id) parts.push('Lead ref: ' + data.lead_id);
    parts.push('Page: ' + location.pathname + location.search);
    return parts.join('\n');
  }
  function sendLead(form, data, hs) {
    var ids = hs.split('/');
    var fields = [
      { name: 'firstname', value: data.firstname || '' },
      { name: 'lastname', value: data.lastname || '' },
      { name: 'email', value: data.email || '' },
      { name: 'phone', value: data.phone || '' },
      { name: 'company', value: data.company || '' },
      { name: 'message', value: summary(form, data) },
      { name: 'home_commercial', value: data.buyer_type === 'HOME' ? 'HOME' : 'COMMERCIAL' } // the visitor's own answer; COMMERCIAL only if none (HubSpot requires one)
    ];
    if (data.utm_source) fields.push({ name: 'utm_source', value: data.utm_source });
    var body = { fields: fields.filter(function (f) { return f.value !== ''; }), context: { pageUri: location.href, pageName: document.title } };
    var hutk = cookieVal('hubspotutk'); if (hutk) body.context.hutk = hutk;
    var hsReq = fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + ids[0] + '/' + ids[1], {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('hubspot ' + r.status); return r; });
    // Gym Launch: also hand the sign-up to the portal so it emails the magic link.
    // The portal sends no CORS header for this domain yet, so this is a no-cors "fire and forget";
    // HubSpot is the record of the lead either way.
    var portal = form.getAttribute('data-portal');
    if (portal) setTimeout(function () { // c.js builds the portal payload in its own submit listener, which runs after this one
      if (!window.verveGymLaunchPayload) return;
      try { fetch(portal, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(window.verveGymLaunchPayload) }).catch(function () {}); } catch (e) {}
    }, 0);
    return hsReq;
  }

  function scrollIntoViewIfNeeded(el) {
    if (el.closest('dialog')) { el.scrollIntoView({ block: 'nearest' }); return; }
    var r = el.getBoundingClientRect();
    if (r.top < 70 || r.top > window.innerHeight * 0.5) {
      window.scrollTo({ top: window.scrollY + r.top - 90, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  /* ---------- video modal ---------- */
  function initVideo() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-video]');
      if (!t) return;
      e.preventDefault();
      var m = document.createElement('div');
      m.className = 'vmodal';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-label', t.getAttribute('data-title') || 'Video');
      m.innerHTML = '<video controls playsinline autoplay src="' + t.getAttribute('data-video') + '"' + (t.getAttribute('data-poster') ? ' poster="' + t.getAttribute('data-poster') + '"' : '') + '></video><button class="vmodal__x" aria-label="Close video">&times;</button>';
      document.body.appendChild(m);
      document.body.style.overflow = 'hidden';
      var v = m.querySelector('video');
      function close() { v.pause(); m.remove(); document.body.style.overflow = ''; t.focus(); }
      m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.closest('.vmodal__x')) close(); });
      document.addEventListener('keydown', function esc(ev) { if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
      m.querySelector('.vmodal__x').focus();
      track('video_open', { video: t.getAttribute('data-title') || '' });
    });
  }

  /* ---------- review note ---------- */
  function initNote() {
    var n = document.querySelector('.cnote');
    if (!n) return;
    if (store.get('verve_note_off') === '1') { n.remove(); return; }
    var b = n.querySelector('button');
    if (b) b.addEventListener('click', function () { n.remove(); store.set('verve_note_off', '1'); });
  }

  function boot() {
    setAud(initialAud());
    applyAngle();
    initChrome();
    initForms();
    initQuick();
    initVideo();
    initNote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Copied from Commercial Pages Redesign/concepts/d-book-a-call/d.js (page D, live on /pages/book-a-call) on 15 Oct 2026 for the
   Graeme Holm advertorial. Changes: page_type comes from data-page-type on the card, and when the card is open in a <dialog>
   sheet, scrolling happens inside the sheet. Everything else is page D's tested booking flow.
   Page D: book a call (6 Oct 2026). No dependencies.
   The booking card talks to the same public booking API as /pages/book-a-call (flow.vervefitness.ai, Niall's system):
     GET  <api>/slots?from=YYYY-MM-DD&to=YYYY-MM-DD&duration=15|30   -> { duration, slots: [ISO start, ...] }
     POST <api>/book { start, duration, name, email, phone, company, topic, channel, tz, turnstile_token, idempotency_key }
          -> 200 { ok, booking: { start, duration, rep_name, channel, teams_join_url, manage_token } } | 409 taken | 403 check failed
   15-minute calls went live on the API on 6 Oct 2026 (Niall). The page always sends the length the visitor picked.
   Every booking (and every call-back request) also goes to HubSpot, like the other B2B pages, with the buyer type,
   lease, postcode, offer version and the time booked in the message.
   The Shopify build sets data-api, data-turnstile and data-hubspot on [data-booking]. Without data-api (the concept file)
   the calendar shows demo times and nothing is sent anywhere. */
(function () {
  'use strict';
  var root = document.querySelector('[data-booking]');
  if (!root) return;
  var PAGE_TYPE = root.getAttribute('data-page-type') || 'book-a-call';

  var params = (function () { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } })();
  var OFFER = /^call$/i.test(params.get('offer') || '') ? 'call' : 'design';
  document.documentElement.classList.toggle('offer-call', OFFER === 'call');
  var OFFER_NAME = { design: 'Free 3D gym design', call: 'Talk to a fit-out specialist' };

  var API = root.getAttribute('data-api') || '';
  var SITEKEY = root.getAttribute('data-turnstile') || '';
  var HS = root.getAttribute('data-hubspot') || '';
  var REP = (params.get('rep') || '').trim();

  /* Cancel links (booking emails and the booked panel) open /pages/book-a-call?manage=<token>. Niall's booking system owns
     cancelling, so on such a link the card hands over to his own widget, which reads the token from the address. */
  var MANAGE = (params.get('manage') || '').trim();
  if (MANAGE) {
    root.setAttribute('data-step', 'manage');
    var head = root.querySelector('.bk__head b'); if (head) head.textContent = 'YOUR BOOKING';
    var body = root.querySelector('.bk__body');
    body.innerHTML = '<div id="verve-booking"></div>';
    if (API) {
      var w = document.createElement('script');
      w.src = API + '/widget';
      w.defer = true;
      document.body.appendChild(w);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'verve_booking_manage_open', offer: OFFER, page_type: PAGE_TYPE });
    return;
  }
  // Booking window (Brandon, 6 Oct 2026): the rest of this calendar week plus all of next week (weeks run Monday to Sunday).
  // The booking system itself opens about 3 weeks ahead; the page shows less.
  function windowEnd(today) { var p = parts(today), mon = (new Date(Date.UTC(p.y, p.m, p.d)).getUTCDay() + 6) % 7; return addDays(today, 6 - mon + 7); }
  var TEXT_LINE = '0468 003 121';

  var TZ = (function () {
    var z = 'Australia/Brisbane';
    try { z = Intl.DateTimeFormat().resolvedOptions().timeZone || z; new Date().toLocaleString('en-AU', { timeZone: z }); } catch (e) { z = 'Australia/Brisbane'; }
    return z;
  })();
  var TZ_LABEL = TZ.split('/').pop().replace(/_/g, ' ') + ' time';

  function q(s) { return root.querySelector(s); }
  var el = {
    grid: q('.bk__grid'), month: q('.bk__month'), prev: q('[data-month="-1"]'), next: q('[data-month="1"]'), status: q('.bk__status'),
    slots: q('.bk__slots'), dayname: q('.bk__dayname'), flash: q('.bk__flash'), tz: q('.bk__tz'), form: q('#bk-form'), err: q('#bk-form .fx__err'),
    when: q('.bk__when'), whensub: q('.bk__whensub'), change: q('.bk__change'), done: q('.bk__done'), go: q('.bk__go'),
    lease: q('[data-lease]'), channel: q('[data-channel]')
  };
  var lenBox = q('[data-len]');
  var state = { byDay: {}, days: [], month: null, minMonth: null, maxMonth: null, day: null, slot: null, mode: 'book', busy: false, rep: null,
    duration: +((lenBox && lenBox.querySelector('input:checked')) || { value: 30 }).value }; // the default length is the tile marked checked in the HTML
  var cache = {}; // open times per call length, so switching 15 / 30 is instant
  var swappedAt = 0; // the times appear where the days were: a double tap must not also pick a time

  /* ---------- helpers ---------- */
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'verve_' + name, offer: OFFER, page_type: PAGE_TYPE }, data || {}));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dayKey(iso) { return new Date(iso).toLocaleDateString('en-CA', { timeZone: TZ }); } // YYYY-MM-DD in the visitor's zone
  function todayKey() { return new Date().toLocaleDateString('en-CA', { timeZone: TZ }); }
  function parts(k) { var p = k.split('-'); return { y: +p[0], m: +p[1] - 1, d: +p[2] }; }
  function keyOf(y, m, d) { var t = new Date(Date.UTC(y, m, d)); return t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()); }
  function addDays(k, n) { var p = parts(k); return keyOf(p.y, p.m, p.d + n); }
  function fmtDay(k, opts) { var p = parts(k); return new Date(Date.UTC(p.y, p.m, p.d, 12)).toLocaleDateString('en-AU', Object.assign({ timeZone: 'UTC' }, opts)); }
  function fmtTime(iso) { return new Date(iso).toLocaleTimeString('en-AU', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: true }).replace(/\s/g, '').toLowerCase(); }
  function longWhen(iso) { return fmtDay(dayKey(iso), { weekday: 'long', day: 'numeric', month: 'long' }) + ' at ' + fmtTime(iso); }
  function monthIndex(o) { return o.y * 12 + o.m; }
  function wide() { return root.clientWidth >= 600; } // matches the @container rule in d.css
  function leadId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'vl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function idemKey(slot) {
    var k = 'vb_idem_' + slot, v = null;
    try { v = sessionStorage.getItem(k); if (!v) { v = leadId(); sessionStorage.setItem(k, v); } } catch (e) { v = leadId(); }
    return v;
  }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function sheet() { var d = root.closest('dialog'); return d && d.open ? d : null; } // the card can be moved into a sheet
  function scrollBy(top) {
    var d = sheet(), b = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (d) d.scrollTo({ top: d.scrollTop + top, behavior: b }); else window.scrollTo({ top: window.scrollY + top, behavior: b });
  }
  function viewTop() { var d = sheet(); return d ? d.getBoundingClientRect().top + 64 : 0; } // 64: the sheet's sticky title bar
  function viewH() { var d = sheet(); return d ? d.clientHeight : window.innerHeight; }
  function inViewCentre(node) {
    var r = node.getBoundingClientRect();
    scrollBy(r.top - viewTop() - viewH() / 3);
  }
  function inView(node) {
    var r = node.getBoundingClientRect(), t = r.top - viewTop();
    if (t < 8 || t > viewH() * 0.55) scrollBy(t - 12);
  }

  /* ---------- steps ---------- */
  function setStep(s) {
    if (s !== root.getAttribute('data-step')) el.flash.hidden = true; // a message belongs to the step it was shown on
    root.setAttribute('data-step', s);
    el.form.hidden = s !== 'details';
    el.done.hidden = s !== 'done';
  }

  /* ---------- times ---------- */
  function fetchSlots(len) {
    if (cache[len]) return cache[len];
    var from = todayKey(), to = addDays(windowEnd(from), 1); // the API reads dates in UTC, so ask one day more and trim in applySlots
    cache[len] = (API
      ? fetch(API + '/slots?from=' + from + '&to=' + to + '&duration=' + len + (REP ? '&rep=' + encodeURIComponent(REP) : ''), { cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      : demoSlots(len)
    ).catch(function (e) { delete cache[len]; throw e; });
    return cache[len];
  }

  function load(keepDay, fresh) {
    setStep('loading');
    skeleton();
    if (fresh) cache = {}; // after a time was taken, ask again for both lengths
    return fetchSlots(state.duration).then(function (d) {
      applySlots(d, keepDay);
      setStep(keepDay && state.day && !wide() ? 'time' : 'day');
      fetchSlots(state.duration === 15 ? 30 : 15).catch(function () {}); // the other length, ready for a switch
    }).catch(function () {
      el.status.hidden = false;
      el.status.innerHTML = 'We couldn’t load the call times. <button type="button" data-retry>Try again</button>, or call <a href="tel:1300194748" data-call="times-failed">1300 1947 48</a>.';
      el.grid.innerHTML = '';
      el.month.textContent = '';
      el.prev.disabled = el.next.disabled = true;
      setStep('error');
      track('booking_error', { stage: 'slots' });
    });
  }

  function applySlots(d, keepDay, keepEmptyDay) {
      var lastDay = windowEnd(todayKey());
      state.rep = d.rep || null;
      state.byDay = {};
      var soon = Date.now() + 10 * 60 * 1000; // never offer a time that starts in the next ten minutes
      (d.slots || []).forEach(function (iso) {
        if (new Date(iso).getTime() < soon) return;
        var k = dayKey(iso);
        if (k > lastDay) return; // past the booking window in the visitor's own time
        (state.byDay[k] = state.byDay[k] || []).push(iso);
      });
      Object.keys(state.byDay).forEach(function (k) { state.byDay[k].sort(); });
      state.days = Object.keys(state.byDay).sort();
      var t = parts(todayKey());
      var first = state.days.length ? parts(state.days[0]) : t, last = state.days.length ? parts(state.days[state.days.length - 1]) : t;
      state.minMonth = { y: first.y, m: first.m };
      state.maxMonth = { y: last.y, m: last.m };
      state.day = keepDay && (state.byDay[keepDay] || keepEmptyDay) ? keepDay : null;
      if (!state.day && wide() && state.days.length) state.day = state.days[0]; // a wide card shows the first day's times straight away
      state.month = state.day ? { y: parts(state.day).y, m: parts(state.day).m } : { y: state.minMonth.y, m: state.minMonth.m };
      el.tz.textContent = 'Times are in ' + TZ_LABEL + '.';
      if (!state.days.length) {
        el.status.hidden = false;
        el.status.innerHTML = 'No call times are open this week or next. <button type="button" data-callback>Ask us to call you</button> or call <a href="tel:1300194748" data-call="no-times">1300 1947 48</a>.';
        track('booking_error', { stage: 'no_times' });
      } else {
        el.status.hidden = true;
      }
      renderMonth();
      renderTimes();
  }

  function skeleton() {
    var h = '';
    for (var i = 0; i < 35; i++) h += '<span class="bk__day bk__day--skel" aria-hidden="true"></span>';
    el.grid.innerHTML = h;
    el.prev.disabled = el.next.disabled = true;
  }

  function renderMonth() {
    var y = state.month.y, m = state.month.m;
    var lead = (new Date(Date.UTC(y, m, 1)).getUTCDay() + 6) % 7; // weeks start on Monday
    var dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    var today = todayKey(), h = '', cells = 0;
    for (var i = 0; i < lead; i++, cells++) h += '<span class="bk__day bk__day--blank" aria-hidden="true"></span>';
    for (var d = 1; d <= dim; d++, cells++) {
      var k = keyOf(y, m, d), n = (state.byDay[k] || []).length;
      var label = fmtDay(k, { weekday: 'long', day: 'numeric', month: 'long' }) + (n ? ', ' + n + (n === 1 ? ' time' : ' times') + ' open' : ', no times');
      h += '<button type="button" class="bk__day' + (k === today ? ' bk__day--today' : '') + '" data-day="' + k + '"' +
        (n ? ' data-open' : ' disabled') + ' aria-pressed="' + (state.day === k) + '" aria-label="' + esc(label) + '">' + d + '</button>';
    }
    while (cells % 7) { h += '<span class="bk__day bk__day--blank" aria-hidden="true"></span>'; cells++; } // finish the last week only: a sixth empty row wastes a phone's first screen
    el.grid.innerHTML = h;
    el.month.textContent = fmtDay(keyOf(y, m, 1), { month: 'long', year: 'numeric' }).toUpperCase();
    el.prev.disabled = monthIndex(state.month) <= monthIndex(state.minMonth);
    el.next.disabled = monthIndex(state.month) >= monthIndex(state.maxMonth);
  }

  function renderTimes() {
    var k = state.day;
    if (!k) { el.dayname.textContent = 'Pick a day to see the open times.'; el.slots.innerHTML = ''; return; }
    el.dayname.textContent = fmtDay(k, { weekday: 'long', day: 'numeric', month: 'long' });
    var list = state.byDay[k] || [];
    el.slots.innerHTML = list.length
      ? list.map(function (iso) { return '<button type="button" class="bk__slot" data-slot="' + esc(iso) + '">' + fmtTime(iso) + '</button>'; }).join('')
      : '<p class="bk__none">No times left on this day. Pick another day.</p>';
  }

  /* ---------- details ---------- */
  function openDetails(mode) {
    state.mode = mode;
    root.setAttribute('data-mode', mode);
    if (mode === 'book') {
      el.when.textContent = fmtDay(dayKey(state.slot), { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '') + ', ' + fmtTime(state.slot);
      el.whensub.textContent = state.duration + ' minutes, ' + TZ_LABEL;
      el.change.textContent = 'Change';
      mountCheck();
    } else {
      el.when.textContent = 'We call you back';
      el.whensub.textContent = 'Usually within 5 minutes during business hours';
      el.change.textContent = 'Pick a time';
    }
    hideErr();
    el.status.hidden = true;
    setStep('details');
    inView(root);
    var first = el.form.querySelector('input[name="phone"]');
    if (first && matchMedia('(pointer: fine)').matches) first.focus({ preventScroll: true }); // phones: no keyboard until they tap a field
    track('booking_step', { step: mode === 'book' ? 'time' : 'callback' });
  }

  function syncLease() {
    var b = el.form.querySelector('input[name="buyer_type"]:checked');
    var show = !b || b.value === 'COMMERCIAL';
    el.lease.hidden = !show;
    el.lease.querySelectorAll('input').forEach(function (i) { i.disabled = !show; });
  }

  function hideErr() {
    el.err.hidden = true;
    el.form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
  }
  function showErr(msg, focusNode) {
    el.err.hidden = false;
    el.err.textContent = msg;
    if (focusNode) focusNode.focus();
  }

  function validate() {
    hideErr();
    var f = el.form, miss = [], firstBad = null;
    function bad(node, word) { node.setAttribute('aria-invalid', 'true'); miss.push(word); if (!firstBad) firstBad = node.matches('fieldset') ? node.querySelector('input') : node; }
    var phone = f.elements.phone, pc = f.elements.postcode, name = f.elements.fullname, email = f.elements.email;
    if ((phone.value.replace(/\D/g, '')).length < 8) bad(phone, 'mobile');
    if (!/^\d{4}$/.test(pc.value.trim())) bad(pc, 'site postcode');
    if (!name.value.trim()) bad(name, 'name');
    if (!email.checkValidity() || !email.value.trim()) bad(email, 'email');
    var buyer = f.querySelector('input[name="buyer_type"]:checked');
    if (!buyer) bad(f.querySelector('input[name="buyer_type"]').closest('fieldset'), 'commercial or home');
    var leaseMissing = buyer && buyer.value === 'COMMERCIAL' && !f.querySelector('input[name="lease"]:checked');
    if (leaseMissing) { el.lease.setAttribute('aria-invalid', 'true'); if (!firstBad) firstBad = el.lease.querySelector('input'); }
    if (!miss.length && !leaseMissing) return true;
    var words = miss.length > 1 ? miss.slice(0, -1).join(', ') + ' and ' + miss[miss.length - 1] : miss[0];
    var msg = miss.length ? 'Add your ' + words + (leaseMissing ? ', and choose where your lease is at.' : '.') : 'Choose where your lease is at.';
    if (miss.indexOf('site postcode') > -1) msg += ' The postcode is 4 digits.';
    showErr(msg, firstBad);
    return false;
  }

  function collect() {
    var f = el.form;
    function v(n) { var i = f.elements[n]; return i && i.value ? String(i.value).trim() : ''; }
    function picked(n) { var i = f.querySelector('input[name="' + n + '"]:checked:not(:disabled)'); return i ? i.value : ''; }
    var full = v('fullname').replace(/\s+/g, ' '), bits = full.split(' ');
    var d = {
      fullname: full, firstname: bits.shift() || '', lastname: bits.join(' '),
      email: v('email'), phone: v('phone'), postcode: v('postcode'),
      buyer_type: picked('buyer_type'), lease: picked('lease'),
      channel: state.mode === 'book' ? (picked('channel') || 'phone') : '',
      lead_id: leadId(), offer: OFFER
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) d[k] = params.get(k); });
    return d;
  }

  /* what the rep sees on the invite ("Topic" / "What we'll cover"). A Teams customer sees it too, so it holds only their own
     answers; the page version goes to HubSpot instead. The booking system cuts it at 300 characters. */
  function topic(d) {
    return [d.buyer_type === 'HOME' ? 'Home gym' : 'Commercial gym, studio or facility',
      d.lease ? 'Lease: ' + d.lease : '', 'Site postcode: ' + d.postcode].filter(Boolean).join(' | ').slice(0, 300);
  }

  /* what sales sees in HubSpot */
  function summary(d, b, kind) {
    var label = root.getAttribute('data-lead-label-' + OFFER) || 'Call booking (book-a-call page)';
    var how = d.channel === 'teams' ? 'Microsoft Teams video call' : 'phone call';
    var lines = [label];
    if (kind === 'booked') lines.push('Call booked: ' + longWhen(b.start || state.slot) + ' ' + TZ_LABEL + ' (' + how + ', ' + (b.duration || state.duration) + ' minutes)' + (b.rep_name ? ', with ' + b.rep_name : ''));
    if (kind === 'callback') lines.push('Call-back requested (no time picked). Call them back, usually within 5 minutes during business hours.');
    if (kind === 'failed') lines.push('The booking system did not confirm the time. They wanted ' + longWhen(state.slot) + ' ' + TZ_LABEL + ' (' + how + ', ' + state.duration + ' minutes). Call them to lock it in.');
    lines.push('Commercial or home: ' + (d.buyer_type === 'HOME' ? 'Home gym' : 'Commercial gym, studio or facility'));
    if (d.lease) lines.push('Lease: ' + d.lease);
    lines.push('Site postcode: ' + d.postcode);
    lines.push('Page version seen: ' + OFFER_NAME[OFFER] + ' (offer=' + OFFER + ')');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (d[k]) lines.push(k + ': ' + d[k]); });
    lines.push('Lead ref: ' + d.lead_id);
    lines.push('Page: ' + location.pathname + location.search);
    return lines.join('\n');
  }

  function sendHubspot(d, b, kind) {
    if (!HS) return Promise.resolve('concept'); // concept file: nothing is sent
    var ids = HS.split('/');
    var fields = [
      { name: 'firstname', value: d.firstname }, { name: 'lastname', value: d.lastname },
      { name: 'email', value: d.email }, { name: 'phone', value: d.phone },
      { name: 'message', value: summary(d, b, kind) },
      { name: 'home_commercial', value: d.buyer_type === 'HOME' ? 'HOME' : 'COMMERCIAL' } // the visitor's own answer (COMMERCIAL is pre-selected on this page and can be changed)
    ];
    if (d.utm_source) fields.push({ name: 'utm_source', value: d.utm_source });
    var body = { fields: fields.filter(function (f) { return f.value !== ''; }), context: { pageUri: location.href, pageName: document.title } };
    var hutk = cookie('hubspotutk'); if (hutk) body.context.hutk = hutk;
    return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + ids[0] + '/' + ids[1], {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true
    }).then(function (r) { if (!r.ok) throw new Error('hubspot ' + r.status); return 'sent'; });
  }

  /* ---------- the bot check the booking system requires (Cloudflare Turnstile) ---------- */
  var check = { loading: null, widget: null, token: null, failed: false, interactive: false };
  function loadCheck() {
    if (check.loading) return check.loading;
    check.loading = new Promise(function (res, rej) {
      if (window.turnstile) return res(window.turnstile);
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { var n = 0; (function wait() { if (window.turnstile) return res(window.turnstile); if (++n > 50) return rej(new Error('check')); setTimeout(wait, 100); })(); };
      s.onerror = function () { rej(new Error('check blocked')); };
      document.head.appendChild(s);
    });
    return check.loading;
  }
  function mountCheck() {
    if (!SITEKEY || check.widget !== null) return;
    loadCheck().then(function (t) {
      if (check.widget !== null) return;
      check.widget = t.render('#bk-ts', {
        sitekey: SITEKEY, appearance: 'interaction-only', size: 'flexible', // no 'action', same as Niall's own widget, so the backend sees identical tokens
        callback: function (tok) { check.token = tok; check.interactive = false; hideErr(); },
        'expired-callback': function () { check.token = null; },
        'error-callback': function () { check.token = null; },
        // Cloudflare wants a tick ("Verify you are human"): most visitors never see this
        'before-interactive-callback': function () { check.interactive = true; },
        'after-interactive-callback': function () { check.interactive = false; },
        'unsupported-callback': function () { check.failed = true; }
      });
    }).catch(function () { check.failed = true; });
  }
  function resetCheck() {
    check.token = null;
    try { if (window.turnstile && check.widget !== null) window.turnstile.reset(check.widget); } catch (e) {}
  }
  function getToken() {
    if (!API) return Promise.resolve('demo');
    if (!SITEKEY) return Promise.resolve('dev');
    mountCheck();
    return new Promise(function (res, rej) {
      var n = 0;
      (function wait() {
        if (check.token) return res(check.token);
        if (check.interactive) { var i = new Error('tick needed'); i.tick = true; return rej(i); }
        if (check.failed) { var e = new Error('check failed to load'); e.fallback = true; return rej(e); }
        if (++n > 120) { var t = new Error('check timeout'); t.fallback = true; return rej(t); } // no token after 12s and no tick asked: don't lose the lead
        setTimeout(wait, 100);
      })();
    });
  }

  /* ---------- send ---------- */
  function busy(on) {
    state.busy = on;
    el.go.disabled = on;
    if (on) el.go.setAttribute('aria-busy', 'true'); else el.go.removeAttribute('aria-busy');
  }

  function book(d) {
    busy(true);
    getToken().then(function (token) {
      var body = {
        start: state.slot, duration: state.duration, name: d.fullname, email: d.email, phone: d.phone, company: '', topic: topic(d),
        channel: d.channel === 'teams' ? 'teams' : 'phone', tz: TZ, turnstile_token: token, idempotency_key: idemKey(state.slot)
      };
      if (REP) body.rep = REP;
      if (!API) return demoBook(body);
      return fetch(API + '/book', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, data: j }; }); });
    }).then(function (res) {
      if (res.status === 200 && res.data && res.data.ok) {
        var b = res.data.booking || {};
        sendHubspot(d, b, 'booked').catch(function (e) { track('booking_error', { stage: 'hubspot', detail: String(e && e.message) }); });
        finish(d, b, 'booked');
        return;
      }
      busy(false);
      if (res.status === 409) { // someone took it first
        resetCheck();
        track('booking_error', { stage: 'book', status: 409 });
        var day = state.day || dayKey(state.slot);
        load(day, true).then(function () {
          if (!wide()) setStep(state.day ? 'time' : 'day');
          el.flash.hidden = false;
          el.flash.textContent = 'Sorry, someone just booked that time. Pick another one.';
          inView(root);
        });
        return;
      }
      if (res.status === 403) { resetCheck(); track('booking_error', { stage: 'check', status: 403 }); showErr('The security check didn’t pass. Please tap the button again.'); return; }
      if (res.status >= 400 && res.status < 500 && res.data && res.data.error) { resetCheck(); track('booking_error', { stage: 'book', status: res.status }); showErr(String(res.data.error)); return; }
      var e = new Error('book ' + res.status); e.fallback = true; throw e;
    }).catch(function (e) {
      if (e && e.tick) {
        busy(false);
        showErr('Tick “Verify you are human” above, then tap the button again.');
        var box = document.getElementById('bk-ts'); if (box) inViewCentre(box);
        return;
      }
      // the booking system is down or blocked: they still asked for a call, so the lead goes to HubSpot with the time they wanted
      track('booking_error', { stage: 'book', detail: String(e && e.message) });
      sendHubspot(d, null, 'failed').then(function () { finish(d, null, 'failed'); }).catch(function () {
        busy(false);
        showErr('That didn’t go through. Please try again, or call us on 1300 1947 48.');
      });
    });
  }

  function callback(d) {
    busy(true);
    sendHubspot(d, null, 'callback').then(function () { finish(d, null, 'callback'); }).catch(function () {
      busy(false);
      showErr('That didn’t send. Please try again, or call us on 1300 1947 48.');
    });
  }

  function finish(d, b, kind) {
    busy(false);
    var first = d.firstname ? d.firstname.charAt(0).toUpperCase() + d.firstname.slice(1) : 'there';
    var t = el.done.querySelector('.bk__donet');
    var when = el.done.querySelector('.bk__donewhen');
    var list = el.done.querySelector('.bk__next');
    var manage = el.done.querySelector('.bk__manage');
    var rep = b && b.rep_name ? b.rep_name.split(/\s+/)[0] : '';
    var teams = d.channel === 'teams';
    var steps = [];
    if (kind === 'booked') {
      t.innerHTML = 'You’re booked in, ' + esc(first) + '.';
      when.textContent = longWhen(b.start || state.slot) + ', ' + TZ_LABEL + '.';
      steps.push(teams
        ? '<b>Your Microsoft Teams invite is on its way</b> to ' + esc(d.email) + '.' + (b.teams_join_url ? ' <a href="' + esc(b.teams_join_url) + '" target="_blank" rel="noopener">Join the call</a>' : '')
        : '<b>' + esc(rep || 'A fit-out specialist') + ' calls you on ' + esc(d.phone) + '</b> at ' + esc(fmtTime(b.start || state.slot)) + ', for ' + (b.duration || state.duration) + ' minutes.');
    } else {
      t.innerHTML = 'Thanks, ' + esc(first) + '. We’ll call you.';
      when.textContent = kind === 'failed'
        ? 'We’ve got your details. A specialist will call ' + d.phone + ' to lock in ' + longWhen(state.slot) + '.'
        : 'We’ll call ' + d.phone + ', usually within 5 minutes during business hours.';
    }
    steps.push('<b>Have a floor plan?</b> Text it to ' + TEXT_LINE + ' or email <a href="mailto:sales@vervefitness.com.au">sales@vervefitness.com.au</a>. A phone photo of a sketch is enough.');
    steps.push(OFFER === 'design'
      ? '<b>Your free 3D design and itemised quote</b> come back inside a week of the call.'
      : '<b>Want it drawn?</b> Your free 3D design and itemised quote come back inside a week of the call.');
    list.innerHTML = steps.map(function (s) { return '<li>' + s + '</li>'; }).join('');
    if (b && b.manage_token) {
      manage.hidden = false;
      manage.innerHTML = 'Need to change it? <a href="https://www.vervefitness.com.au/pages/book-a-call?manage=' + encodeURIComponent(b.manage_token) + '">Cancel this booking</a> and pick a new time.';
    }
    setStep('done');
    inView(root);
    el.done.focus({ preventScroll: true });
    track('lead', { form: 'bk-form', kind: kind, booked: kind === 'booked', channel: d.channel || 'callback', buyer_type: d.buyer_type === 'HOME' ? 'home' : 'commercial', lease: d.lease || '', lead_id: d.lead_id, duration: kind === 'callback' ? 0 : (b && b.duration) || state.duration });
  }

  /* ---------- concept file only: demo times shaped like the real ones (weekdays, 7am to 3:30pm Brisbane) ---------- */
  function demoSlots(len) {
    var out = [], base = parts(new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Brisbane' }));
    for (var i = 0; i < 21; i++) {
      var day = new Date(Date.UTC(base.y, base.m, base.d + i));
      var dow = day.getUTCDay();
      if (dow === 0 || dow === 6) continue;
      for (var h = 7; h < 16; h += len === 15 ? 0.25 : 0.5) {
        if ((day.getUTCDate() * 3 + h * 2) % 7 === 0) continue; // a few taken times
        out.push(new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), Math.floor(h) - 10, (h % 1) * 60)).toISOString());
      }
    }
    return new Promise(function (r) { setTimeout(function () { r({ duration: 30, slots: out }); }, 350); });
  }
  function demoBook(body) {
    return new Promise(function (r) { setTimeout(function () { r({ status: 200, data: { ok: true, booking: { start: body.start, duration: body.duration, channel: body.channel, rep_name: '', manage_token: '' } } }); }, 500); });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-len]') && !wide() && Date.now() - swappedAt < 400) { e.preventDefault(); return; } // the length tiles sit where the days were
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-day')) {
      state.day = t.getAttribute('data-day');
      swappedAt = Date.now();
      el.status.hidden = true;
      renderMonth(); renderTimes();
      setStep('time');
      if (!wide()) inView(root);
      var firstSlot = el.slots.querySelector('.bk__slot');
      if (firstSlot && !wide()) firstSlot.focus({ preventScroll: true });
      track('booking_step', { step: 'day' });
    } else if (t.hasAttribute('data-month')) {
      var dir = +t.getAttribute('data-month'), mi = monthIndex(state.month) + dir;
      state.month = { y: Math.floor(mi / 12), m: mi % 12 };
      renderMonth();
    } else if (t.hasAttribute('data-slot')) {
      if (!wide() && Date.now() - swappedAt < 400) return;
      state.slot = t.getAttribute('data-slot');
      openDetails('book');
    } else if (t.hasAttribute('data-callback')) {
      state.slot = null;
      openDetails('callback');
    } else if (t.hasAttribute('data-retry')) {
      load();
    } else if (t.getAttribute('data-to') === 'day') {
      setStep('day');
    } else if (t.getAttribute('data-to') === 'time') { // "Change" / "Pick a time" on the details step
      state.mode = 'book';
      root.setAttribute('data-mode', 'book');
      setStep(state.day && !wide() ? 'time' : 'day');
      if (!state.day && wide() && state.days.length) { state.day = state.days[0]; renderMonth(); renderTimes(); }
      inView(root);
    }
  });
  // 15 or 30 minutes: show the open times for that length and keep the visitor's day where it still has times
  if (lenBox) lenBox.addEventListener('change', function (e) {
    var len = +e.target.value;
    if (!len || len === state.duration) return;
    state.duration = len;
    track('booking_length', { duration: len });
    var step = root.getAttribute('data-step'), keep = state.day;
    el.slots.innerHTML = '<p class="bk__none">Loading times…</p>';
    fetchSlots(len).then(function (d) {
      if (state.duration !== len) return; // switched again while this was loading
      applySlots(d, keep, true);
      setStep(step === 'time' && !wide() ? 'time' : 'day');
    }).catch(function () {
      el.slots.innerHTML = '<p class="bk__none">We couldn’t load those times. Try again, or call 1300 1947 48.</p>';
    });
  });
  el.form.addEventListener('change', function (e) {
    if (e.target.name === 'buyer_type') { syncLease(); track('buyer_type_change', { to: e.target.value === 'HOME' ? 'home' : 'commercial' }); }
    var fs = e.target.closest('[aria-invalid]'); if (fs) fs.removeAttribute('aria-invalid');
    clearErrIfFixed();
  });
  el.form.addEventListener('input', function (e) { if (e.target.hasAttribute('aria-invalid')) e.target.removeAttribute('aria-invalid'); clearErrIfFixed(); });
  function clearErrIfFixed() { if (!el.err.hidden && !el.form.querySelector('[aria-invalid]')) el.err.hidden = true; } // everything it flagged is fixed: drop the red message
  el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.busy || !validate()) return;
    var d = collect();
    if (state.mode === 'callback') callback(d); else book(d);
  });

  // every "book a call time" button outside the card brings the visitor to it
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (a) track('call_click', { from: a.getAttribute('data-call') || '' });
    var j = e.target.closest && e.target.closest('[data-book-jump]');
    if (!j) return;
    e.preventDefault();
    var top = root.getBoundingClientRect().top + window.scrollY - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    track('book_jump', { from: j.getAttribute('data-book-jump') });
  });

  // a resize across the two-pane width keeps the visitor's step sensible
  var wasWide = wide();
  addEventListener('resize', function () {
    var w = wide();
    if (w === wasWide) return;
    wasWide = w;
    var s = root.getAttribute('data-step');
    if (w && s === 'time') setStep('day');
    if (w && !state.day && state.days.length) { state.day = state.days[0]; renderMonth(); renderTimes(); }
  });

  syncLease();
  load();
})();

/* logo strip: mark it scrollable (for the edge fade) only when the logos don't all fit, and drop the fade at the end */
(function () {
  var row = document.querySelector('[data-logo-row]');
  if (!row) return;
  var check = function () {
    var scroll = row.scrollWidth > row.clientWidth + 2;
    row.classList.toggle('is-scroll', scroll);
    row.classList.toggle('at-end', scroll && row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
  };
  row.addEventListener('scroll', check, { passive: true });
  addEventListener('resize', check);
  addEventListener('load', check);
  check();
})();

/* Graeme Holm advertorial (15 Oct 2026): the line-up board's filters, the line-up popup and the booking sheet. No dependencies.
   - Line-up popup (round 3, Brandon 15 Oct): every tile opens that machine's details, price and add to cart over the page; the
     chapter links ("Show the six two-in-ones") open a list of just those machines. Closing returns the reader to where they were.
     Data comes from the #makoto-data block (tools/build-products.py). The Shopify build sets data-live on the board: the popup
     then refreshes price and stock from /products/<handle>.js and adds with /cart/add.js. Without it (review copy), ADD TO CART
     opens the store's own cart-add link in a new tab.
   - Booking sheet: every [data-book-open] button moves page D's booking card (book.js) from the end of the page into a sheet
     where the visitor is, and back again on close, so there is only ever one card and one booking. */
(function () {
  'use strict';
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'verve_' + name, page_type: 'advertorial' }, data || {}));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-AU'); }
  var STORE = 'https://www.vervefitness.com.au';
  var WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  var still = matchMedia('(prefers-reduced-motion: reduce)');
  var root = document.documentElement;

  /* ---------- the phone's back gesture closes a sheet instead of leaving the page ----------
     Most readers arrive from a Meta ad: without this, swiping back with a sheet open goes back to Facebook. Opening a sheet
     adds one history step; closing it any other way takes that step back. Swapping the line-up popup for the booking sheet
     keeps the same step (the close event fires after the other sheet is already open). */
  var sheetsOpen = function () { return [].some.call(document.querySelectorAll('dialog'), function (d) { return d.open; }); };
  var hist = { pushed: false, popping: false };
  function sheetOpened() {
    if (hist.pushed) return;
    try { history.pushState({ vcSheet: 1 }, ''); hist.pushed = true; } catch (e) {}
  }
  function sheetClosed() {
    if (hist.popping || sheetsOpen() || !hist.pushed) return;
    hist.pushed = false;
    history.back();
  }
  addEventListener('popstate', function () {
    if (!hist.pushed) return;
    hist.pushed = false;
    hist.popping = true;
    [].forEach.call(document.querySelectorAll('dialog'), function (d) { if (d.open) d.close(); });
    setTimeout(function () { hist.popping = false; }, 0); // the close events fire after this
  });

  /* ---------- line-up board: filters ---------- */
  var board = document.querySelector('[data-lineup]');
  var tiles = board ? board.querySelectorAll('li[data-k]') : [];
  if (board) {
    var count = board.querySelector('[data-lineup-count]');
    var btns = board.querySelectorAll('[data-f]');
    Array.prototype.forEach.call(tiles, function (t, i) { t.style.setProperty('--i', i); });
    var filter = function (f) {
      var n = 0;
      Array.prototype.forEach.call(tiles, function (t) {
        var on = matches(t, f);
        t.classList.toggle('is-off', !on);
        if (on) n++;
      });
      Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-f') === f)); });
      count.textContent = f === 'all' ? '' : n + ' SHOWN'; // no total on the page (Brandon, 15 Oct: "more than 25")
    };
    board.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]');
      if (!b) return;
      filter(b.getAttribute('data-f'));
      track('lineup_filter', { filter: b.getAttribute('data-f'), from: 'board' });
    });
    // the tiles settle in once, the first time the board comes into view
    if ('IntersectionObserver' in window && !still.matches) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        board.classList.add('is-in');
        io.disconnect();
      }, { threshold: 0.12 });
      io.observe(board);
    }
  }
  function matches(t, f) { return f === 'all' || (' ' + t.getAttribute('data-k') + ' ').indexOf(' ' + f + ' ') > -1; }

  /* ---------- line-up popup: category list + product view ---------- */
  var DATA = {};
  try { DATA = JSON.parse((document.getElementById('makoto-data') || {}).textContent || '{}'); } catch (e) {}
  var LIVE = !!(board && board.hasAttribute('data-live'));
  var pv = document.getElementById('pview');
  var pvOk = pv && typeof pv.showModal === 'function' && board;
  var st = { view: null, filter: null, key: null, colour: 'brown', qty: 1, opener: null };
  if (pvOk) {
    var bar = { back: pv.querySelector('[data-pv-back] span'), h: pv.querySelector('.pview__h') };
    var listEl = pv.querySelector('[data-pv-list]'), grid = listEl.querySelector('.pview__grid'), itemEl = pv.querySelector('[data-pv-item]');

    var LIST_NAME = {
      all: function () { return 'Graeme’s Makoto line-up'; },
      pin: function (n) { return 'The ' + (n < 10 ? WORDS[n] : n) + ' pin-loaded machines'; },
      plate: function (n) { return 'The ' + (n < 10 ? WORDS[n] : n) + ' plate-loaded machines'; },
      combo: function (n) { return 'The ' + (n < 10 ? WORDS[n] : n) + ' two-in-ones'; }
    };
    var show = function (view) {
      st.view = view;
      listEl.hidden = view !== 'list';
      itemEl.hidden = view !== 'item';
      bar.back.textContent = view === 'item' && st.filter ? 'BACK TO THE LIST' : 'BACK TO THE STORY';
      pv.scrollTop = 0;
    };
    var openDialog = function (opener) {
      if (pv.open) return;
      st.opener = opener || null;
      root.classList.add('qs-open');
      pv.showModal();
      pv.focus({ preventScroll: true }); // focus the sheet, not its first button (iPhone Safari draws a ring on it)
      sheetOpened();
    };

    var openList = function (f, opener) {
      var picked = Array.prototype.filter.call(tiles, function (t) { return matches(t, f); });
      st.filter = f;
      bar.h.textContent = LIST_NAME[f] ? LIST_NAME[f](picked.length) : 'Graeme’s Makoto line-up';
      grid.innerHTML = '';
      picked.forEach(function (t) { var c = t.cloneNode(true); c.classList.remove('is-off'); c.removeAttribute('style'); grid.appendChild(c); });
      show('list');
      openDialog(opener);
      track('lineup_open', { filter: f });
    };

    var openItem = function (key, opener, fromList) {
      var d = DATA[key];
      if (!d) return false;
      if (!fromList) st.filter = null;
      st.key = key; st.colour = 'brown'; st.qty = 1;
      bar.h.textContent = st.filter ? LIST_NAME[st.filter](grid.children.length) : 'Graeme’s Makoto line-up';
      renderItem();
      show('item');
      openDialog(opener);
      track('product_view', { product: key, handle: d.brown.handle, from: fromList ? 'list' : 'board' });
      if (LIVE) refresh(key);
      return true;
    };

    var offer = function () { var d = DATA[st.key]; return st.colour === 'black' && d.black ? d.black : d.brown; };

    var renderItem = function () {
      var d = DATA[st.key], o = offer();
      var pics = st.colour === 'black' && d.black ? [d.black.img] : [d.img].concat(d.photos || []);
      var feats = d.feats || [], specs = d.specs || [];
      var addHref = STORE + '/cart/add?id=' + o.id + '&quantity=' + st.qty;
      itemEl.innerHTML =
        '<div class="pv">' +
          '<div class="pv__gal">' +
            '<div class="pv__main"><img src="' + esc(pics[0]) + '" alt="' + esc(d.name) + ', ' + st.colour + ' upholstery"></div>' +
            (pics.length > 1 ? '<div class="pv__thumbs">' + pics.map(function (src, i) {
              return '<button type="button" class="pv__thumb" data-pic="' + esc(src) + '" aria-label="Photo ' + (i + 1) + ' of ' + pics.length + '" aria-pressed="' + (i === 0) + '"><img src="' + esc(src) + '" alt="" loading="lazy"></button>';
            }).join('') + '</div>' : '') +
          '</div>' +
          '<div class="pv__info">' +
            '<p class="pv__tag" data-pv-status>' + esc(o.status) + '</p>' +
            '<p class="pv__series">MAKOTO COMMERCIAL SERIES, ' + esc(d.type.toUpperCase()) + '</p>' +
            '<h3 class="pv__title">' + esc(d.name) + '</h3>' +
            '<p class="pv__price" data-pv-price><b>' + money(o.price) + '</b>' + (o.was ? '<s>' + money(o.was) + '</s>' : '') + '</p>' +
            (d.black ? '<fieldset class="pv__colour"><legend>Upholstery</legend><div class="pv__tiles">' +
              ['brown', 'black'].map(function (c) {
                return '<label class="pv__tile"><input type="radio" name="pv_colour" value="' + c + '"' + (st.colour === c ? ' checked' : '') + '><span>' + c.toUpperCase() + '</span></label>';
              }).join('') + '</div><p class="pv__note">' + (st.colour === 'brown' ? 'The upholstery on Graeme’s floor.' : 'The same machine with black upholstery.') + '</p></fieldset>'
              : '<p class="pv__note">The version on Graeme’s floor.</p>') +
            '<div class="pv__buy">' +
              '<div class="pv__qty" role="group" aria-label="Quantity"><button type="button" data-qty="-1" aria-label="One fewer">−</button><output aria-live="polite">' + st.qty + '</output><button type="button" data-qty="1" aria-label="One more">+</button></div>' +
              (LIVE
                ? '<button type="button" class="btn btn--primary pv__add" data-pv-add>ADD TO CART <svg class="chev"><use href="#v"/></svg></button>'
                : '<a class="btn btn--primary pv__add" data-pv-add href="' + esc(addHref) + '" target="_blank" rel="noopener">ADD TO CART <svg class="chev"><use href="#v"/></svg></a>') +
            '</div>' +
            '<div class="pv__added" data-pv-added hidden></div>' +
            '<p class="pv__err fx__err" data-pv-err hidden></p>' +
            '<a class="pv__more textlink" href="' + esc(LIVE ? '/products/' + o.handle : o.url) + '" target="_blank" rel="noopener">See the full product page <svg class="chev"><use href="#v"/></svg></a>' +
            (feats.length ? '<ul class="pv__feats">' + feats.slice(0, 5).map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>' : '') +
            (feats.length > 5 ? '<details class="pv__dt"><summary>All ' + feats.length + ' features<i></i></summary><ul class="pv__feats">' + feats.slice(5).map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul></details>' : '') +
            (specs.length ? '<details class="pv__dt"' + (feats.length ? '' : ' open') + '><summary>Specifications<i></i></summary><table class="pv__specs">' + specs.map(function (r) { return '<tr><th>' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>'; }).join('') + '</table></details>' : '') +
            '<p class="pv__floor">Planning a whole floor? <button type="button" data-book-open="product-' + esc(st.key) + '">Book a free 3D design call</button> and we’ll lay out the line-up with you.</p>' +
          '</div>' +
        '</div>';
    };

    // the store's current price and stock (Shopify build only)
    var refresh = function (key) {
      var d = DATA[key];
      ['brown', 'black'].forEach(function (c) {
        var o = d[c]; if (!o) return;
        fetch('/products/' + o.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
          if (!j) return;
          var v = j.variants && j.variants[0]; if (!v) return;
          o.id = v.id; o.price = v.price / 100; o.was = v.compare_at_price > v.price ? v.compare_at_price / 100 : 0;
          var t = j.title || '', m = t.match(/Pre-Order ETA ([A-Za-z ]+)/i);
          o.status = m ? 'PRE-ORDER, ETA ' + m[1].trim().toUpperCase() : /MADE TO ORDER/i.test(t) ? 'MADE TO ORDER' : v.available ? 'IN STOCK' : 'SOLD OUT';
          o.available = !!v.available;
          if (st.key === key && st.colour === c && st.view === 'item') {
            itemEl.querySelector('[data-pv-status]').textContent = o.status;
            itemEl.querySelector('[data-pv-price]').innerHTML = '<b>' + money(o.price) + '</b>' + (o.was ? '<s>' + money(o.was) + '</s>' : '');
            var add = itemEl.querySelector('[data-pv-add]'); if (add) add.disabled = !o.available;
          }
        }).catch(function () {});
      });
    };

    var added = function (msg, checkout) {
      var box = itemEl.querySelector('[data-pv-added]');
      box.innerHTML = '<svg aria-hidden="true"><use href="#tick"/></svg><p>' + msg + '</p><div>' +
        (checkout ? '<a class="btn btn--primary" href="/checkout">CHECKOUT <svg class="chev"><use href="#v"/></svg></a>' : '') +
        '<button type="button" class="btn btn--outline" data-pv-close>KEEP READING</button></div>';
      box.hidden = false;
      box.scrollIntoView({ block: 'nearest', behavior: still.matches ? 'auto' : 'smooth' });
    };

    // clicks: tiles (board and list), chapter links, back, close, colour, quantity, photos, add
    document.addEventListener('click', function (e) {
      var t = e.target;
      var tile = t.closest('.lu[data-p]');
      if (tile) { e.preventDefault(); openItem(tile.getAttribute('data-p'), tile, !!tile.closest('#pview')); return; }
      var showBtn = t.closest('[data-lineup-show]');
      if (showBtn) { e.preventDefault(); openList(showBtn.getAttribute('data-lineup-show'), showBtn); }
    });
    pv.addEventListener('click', function (e) {
      var t = e.target;
      if (t === pv || t.closest('[data-pv-close]')) { pv.close(); return; }
      if (t.closest('[data-pv-back]')) { if (st.view === 'item' && st.filter) show('list'); else pv.close(); return; }
      var pic = t.closest('[data-pic]');
      if (pic) {
        itemEl.querySelector('.pv__main img').src = pic.getAttribute('data-pic');
        itemEl.querySelectorAll('[data-pic]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === pic)); });
        return;
      }
      var q = t.closest('[data-qty]');
      if (q) {
        st.qty = Math.max(1, Math.min(9, st.qty + +q.getAttribute('data-qty')));
        itemEl.querySelector('.pv__qty output').textContent = st.qty;
        var a = itemEl.querySelector('a[data-pv-add]'); if (a) a.href = STORE + '/cart/add?id=' + offer().id + '&quantity=' + st.qty;
        return;
      }
      var add = t.closest('[data-pv-add]');
      if (add) {
        var o = offer(), d = DATA[st.key];
        track('add_to_cart', { product: st.key, handle: o.handle, variant_id: o.id, quantity: st.qty, price: o.price, value: o.price * st.qty, colour: st.colour, live: LIVE });
        if (!LIVE) { added('Added. Your cart is open in a new tab on vervefitness.com.au.', false); return; } // the link opens the store's cart-add
        e.preventDefault();
        // Bold's cart listener still arrives with the store's header scripts, but the landing layout strips Bold itself, so it
        // throws on every cart change. A do-nothing emitter, only when Bold isn't on the page, keeps the console clean.
        var B = window.BOLD = window.BOLD || {}; B.common = B.common || {};
        if (!B.common.eventEmitter) B.common.eventEmitter = { emit: function () {}, on: function () {} };
        var err = itemEl.querySelector('[data-pv-err]'); err.hidden = true;
        add.disabled = true; add.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: o.id, quantity: st.qty }] }) })
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function () { added(st.qty + ' × ' + esc(d.name) + ' (' + st.colour + ') added to your cart.', true); })
          .catch(function () { err.hidden = false; err.textContent = 'That didn’t add to your cart. Please try again, or call us on 1300 1947 48.'; })
          .then(function () { add.disabled = false; add.removeAttribute('aria-busy'); });
      }
    });
    pv.addEventListener('change', function (e) {
      if (e.target.name !== 'pv_colour') return;
      st.colour = e.target.value;
      renderItem();
      itemEl.querySelector('input[name="pv_colour"]:checked').focus();
      track('product_colour', { product: st.key, colour: st.colour });
    });
    pv.addEventListener('close', function () {
      sheetClosed();
      if (!sheetsOpen()) root.classList.remove('qs-open'); // another sheet may have just opened (popup -> booking sheet)
      st.view = null; st.filter = null;
      if (st.opener && document.contains(st.opener)) st.opener.focus({ preventScroll: true });
    });
  }

  /* ---------- booking sheet ---------- */
  var card = document.querySelector('[data-booking]');
  var home = document.querySelector('[data-card-home]');
  var dlg = document.getElementById('bsheet');
  var slot = dlg && dlg.querySelector('[data-card-sheet]');
  var opener = null;
  function closeSheet() { if (dlg && dlg.open) dlg.close(); }
  if (card && home && dlg && slot && typeof dlg.showModal === 'function') {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-book-open]');
      if (!b) return;
      e.preventDefault();
      var from = b.getAttribute('data-book-open');
      track('book_open', { from: from });
      var inPopup = pv && pv.open && pv.contains(b);
      if (inPopup) { st.opener = null; pv.close(); } // from a machine in the popup: swap the popup for the booking sheet
      var r = home.getBoundingClientRect();
      if (!inPopup && r.top < window.innerHeight * 0.6 && r.bottom > 120) return; // the card is already on screen
      opener = inPopup ? null : b;
      slot.appendChild(card);
      root.classList.add('qs-open');
      dlg.showModal();
      dlg.focus({ preventScroll: true });
      sheetOpened();
      dlg.scrollTop = 0;
      window.dispatchEvent(new Event('resize')); // book.js re-checks its two-pane width in the sheet
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-bsheet-close]')) closeSheet(); });
    dlg.addEventListener('close', function () {
      sheetClosed();
      home.appendChild(card);
      if (!sheetsOpen()) root.classList.remove('qs-open'); // another sheet may have just opened (popup -> booking sheet)
      window.dispatchEvent(new Event('resize'));
      if (opener) opener.focus({ preventScroll: true });
    });
  } // no <dialog> support: the buttons stay plain links to #book
})();
